/**
 * Global access-token store.
 *
 * The Kinde auth provider writes the latest access token here via
 * `setAccessToken()`. The HTTP transport reads it via `getAccessToken()`
 * and attaches it as a Bearer header.
 *
 * This avoids prop-drilling or context dependency for every page that
 * already calls `buildDefaultClient()`.
 */

let currentToken: string | null = null;

export const setAccessToken = (token: string | null): void => {
  currentToken = token;
};

export const getAccessToken = (): string | null => currentToken;
